import tw from 'twin.macro';

export const Input = tw.input`
focus:bg-gray-200 focus:border focus:border-gray-400
  rounded-lg bg-gray-200 outline-none p-3`;
